<template>
  <v-list-tile>
    <v-list-tile-content>
      <v-list-tile-title> {{ capitalizeEveryWord(specimen.SpeciesCommonName) }} ({{ specimen.SpeciesFullLatinName }})
      </v-list-tile-title>
      <v-list-tile-sub-title>
        <v-layout row wrap>
          <v-flex xs12 sm8>
            <v-layout row wrap>
              <!-- <v-flex xs12 v-if="specimen.SpeciesFullLatinName != null">
                <span class='text--primary'>Id: </span>{{specimen.Id}}
              </v-flex> -->
              <v-flex xs12 v-if="specimen.SpeciesCode != null">
                <span class='text--primary'>Species Code: </span>{{ specimen.SpeciesCode }}
              </v-flex>
              <v-flex xs12>
                <span class='text--primary'>{{ specimen.Surveys.length}}</span> Surveys
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs12 sm4>
            <v-btn small round @click="$router.push(`/vegetativemonitoring/specimen/${specimen.Id}`)"> View</v-btn>
          </v-flex>
        </v-layout>
      </v-list-tile-sub-title>
    </v-list-tile-content>
  </v-list-tile>
</template>
<script>
  import {
    capitalize,
  } from '@/helpers/strings'
  export default {
    props: {
      value: {
        type: Object,
        required: true,
      },
    },
    computed: {
      specimen() {
        return this.value
      },
    },
    methods: {
      capitalizeEveryWord(word) {
        return word
          .split(' ')
          .map(x => capitalize(x))
          .join(' ')
      },
    },
  }
</script>